export default "__VITE_ASSET__BFrzgdfZ__"